<template>
	<v-layout row wrap>
		<v-flex xs12 md6></v-flex>
		<v-flex xs12 md6>
			<v-menu
				ref="menu"
				v-model="menu"
				:close-on-content-click="true"
				transition="scale-transition"
				offset-y
				max-width="290px"
				min-width="290px"
			>
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						v-model="filter.date"
						:label="$t('title.monthly')"
						prepend-icon="mdi-calendar"
						readonly
						v-bind="attrs"
						v-on="on"
					></v-text-field>
				</template>
				<v-date-picker
					v-model="filter.date"
					type="month"
					no-title
					scrollable
				>
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="menu = false"
						>Cancel</v-btn
					>
					<v-btn
						text
						color="primary"
						@click="$refs.menu.save(filter.date)"
						>OK</v-btn
					>
				</v-date-picker>
			</v-menu>
		</v-flex>
	</v-layout>
</template>

<script>
	export default {
		props: ["value"],
		data() {
			return {
				menu: null,
				items: [],
			};
		},
		computed: {
			filter: {
				get() {
					return this.value;
				},
				set(value) {
					this.$emit("input", value);
				},
			},
		},
		watch: {
			filter: {
				handler() {
					this.$emit("filter");
				},
				deep: true,
			},
		},
	};
</script>